import ApiPermisos from '../../services/apiPermisos'

export default {    
    namespaced: true,
    state: {
        loadingOn: false,
        loadingarea:false,
        loadingcl:false,
        loadingcar:false,
        loadingFiltro:false,
        loadingPandA:false,
        error:{},
        message:{},
        SveDash:{},
        SveDashPandA:{},
        SveDash_id:{},
        SveDash_cl:{},
        SveDash_percent:{},
        SveDash_char:{},
        SveDash_Oha:{},
    },
getters: {},
mutations: {
    setLoading: (state, loadingOn) => {
        state.loadingOn = loadingOn;
    },
    setLoadingFiltro: (state, loadingFiltro) => {
        state.loadingFiltro = loadingFiltro;
    },
    setLoadingarea: (state, loadingarea) => {
        state.loadingarea = loadingarea;
    },
    setLoadingcl: (state, loadingcl) => {
        state.loadingcl = loadingcl;
    },
    setloadingPandA: (state, loadingPandA) => {
        state.loadingPandA = loadingPandA;
    },
    setLoadingcar: (state, loadingcar) => {
        state.loadingcar = loadingcar;
    },
    setError:(state, error) => {
        state.error.message = error  
    },
    setMessage:(state, message) => {
        state.error = {}
        state.message = message  
    },
    setSveDashPandA: (state, SveDashPandA) => {
        state.SveDashPandA = SveDashPandA  
    },
    setSveDash: (state, SveDash) => {
        state.SveDash = SveDash  
    },
    SetSveDash_id:(state, SveDash_id) => {
        state.SveDash_id = SveDash_id  
    },
    SetSveDash_cl:(state, SveDash_cl) => {
        state.SveDash_cl = SveDash_cl   
    },
    SetSveDash_pr:(state, SveDash_percent) => {
        state.SveDash_percent = SveDash_percent   
    },
    SetSveDash_Char:(state, SveDash_char) => {
        state.SveDash_char = SveDash_char   
    },
    SetSveDash_Oha:(state, SveDash_Oha) => {
        state.SveDash_Oha = SveDash_Oha   
    },

},
actions: {   

    //Trae los Sve para el Dashboard 

    actGetSveGesOha: async ({
      commit,
    },) => {
      try {
        commit('setLoadingFiltro', true);
        let response = await ApiPermisos.getSveGesOha();
        commit('setLoadingFiltro', false);
        if (response.error) {
            commit('setError', response.error.trace.message[0]);
            return response.error;
        }
        else{
          commit('SetSveDash_Oha', response);
        }
      } catch (error) {
        let error2 = error.response
        commit('setError', error2.data.message);
      }
      },
actGetSveDash_Char: async ({
  commit
},data) => {
  try {
    commit('setLoadingcar', true);
    let response = await ApiPermisos.getSveDash_Char(data);
    commit('setLoadingcar', false);
    if (response.error) {
        commit('setError', response.error.trace.message[0]);
        return response.error;
    }
    else{
      commit('SetSveDash_Char', response);
    }
  } catch (error) {
    let error2 = error.response
    commit('setError', error2.data.message);
  }
  },
actGetSveDash: async ({
  commit
},data) => {
  try {
    commit('setLoading', true);
    let response = await ApiPermisos.getSveDash(data);
    commit('setLoading', false);
    if (response.error) {
        commit('setError', response.error.trace.message[0]);
        return response.error;
    }
    else{
      commit('setSveDash', response);
    }
  } catch (error) {
    let error2 = error.response
    commit('setError', error2.data.message);
  }
  },
  
actSveDashPandA: async ({
  commit
},data) => {
  try {
    commit('setloadingPandA', true);
    let response = await ApiPermisos.getSveDashPandA(data);
    commit('setloadingPandA', false);
    if (response.error) {
        commit('setError', response.error.trace.message[0]);
        return response.error;
    }
    else{
      commit('setSveDashPandA', response);
    }
  } catch (error) {
    let error2 = error.response
    commit('setError', error2.data.message);
  }
  },

actGetSveGesDash: async ({
  commit,
},{data, id, page} ) => {
  try {
    commit('setLoadingarea', true);
    let response = await ApiPermisos.getSveGesDash({data, id, page });
    commit('setLoadingarea', false);
    if (response.error) {
        commit('setError', response.error.trace.message[0]);
        return response.error;
    }
    else{
      commit('SetSveDash_id', response);
    }
  } catch (error) {
    let error2 = error.response
    commit('setError', error2.data.message);
    }
  },


actGetSvePercDash: async ({
  commit,
},data) => {
  try {
    commit('setLoading', true);
    let response = await ApiPermisos.getSvePercDash(data);
    commit('setLoading', false);
    if (response.error) {
        commit('setError', response.error.trace.message[0]);
        return response.error;
    }
    else{
      commit('SetSveDash_pr', response);
    }
  } catch (error) {
    let error2 = error.response
    commit('setError', error2.data.message);
  }
  },
  
actGetSveGesClDash: async ({
  commit,
},data) => {
  try {
    commit('setLoadingcl', true);
    let response = await ApiPermisos.getSveGesClDash(data);
    commit('setLoadingcl', false);
    if (response.error) {
        commit('setError', response.error.trace.message[0]);
        return response.error;
    }
    else{
      commit('SetSveDash_cl', response);
    }
  } catch (error) {
    let error2 = error.response
    commit('setError', error2.data.message);
  }
  },




}
}